exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".span-filter[data-v-38b51ad2]{font-size:12pt;font-weight:700;padding:.3rem 1rem}select.form-control[data-v-38b51ad2]{max-width:10rem}", ""]);

// exports
